import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor () {
    let cssRule;
    cssRule = 'color: #aa5ab0;' +
      'font-size: 60px;' +
      'font-family : Poppins-Regular' +
      'text-align: center' +
      'font-weight: bold;' +
      'text-shadow: 1px 1px 5px #aa5ab0;' +
      'filter: dropshadow(color=#aa5ab0, offx=1, offy=1);';
    setTimeout(console.log.bind(console, '%cPREP UP ADMIN DEV. CONSOLE', cssRule), 0);
  }}



// WEBPACK FOOTER //
// ./src/app/app.component.ts